<template>
  <div>
    <h4 class="text-center mb-4">{{ userInfo.name || userInfo.email }}</h4>
    <a-card
      size="small"
      :title="$t('scope.text_934')"
      hoverable
      class="mb-4"
      :loading="loading"
      v-if="isNotifyEnabled">
      <template #extra>
        <a-button type="link" icon="reload" size="small" @click="fetchContact" style="float: right;" />
      </template>
      <!--a-button type="link" slot="extra" icon="edit" @click="() => updateDialog.visible = true">{{$t('scope.text_234')}}</a-button-->
      <div>
        <div class="d-flex mb-2">
          <div class="user-info-item-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_235')}}</div>
          <div class="flex-fill ml-3">
            <span>{{ contacts.mobile.contact || '-' }}</span>
            <span class="ml-2" v-if="contacts.mobile.status"><contact-status @refresh="fetchContact" :status="contacts.mobile.status" type="mobile" :contact="contacts.mobile.contact" /></span>
          </div>
        </div>
        <div class="d-flex mb-2">
          <div class="user-info-item-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_236')}}</div>
          <div class="flex-fill ml-3">
            <span>{{ contacts.email.contact || '-' }}</span>
            <span class="ml-2" v-if="contacts.email.status"><contact-status @refresh="fetchContact" :status="contacts.email.status" type="email" :contact="contacts.email.contact" /></span>
          </div>
        </div>
        <div class="d-flex">
          <div class="user-info-item-label flex-grow-0 flex-shrink-0 text-right">{{$t('scope.text_237')}}</div>
          <div class="flex-fill ml-3">{{ contacts.enabled ? $t('scope.text_19') : $t('scope.text_20') }}</div>
        </div>
      </div>
    </a-card>
    <a-card
      size="small"
      :title="$t('scope.text_230', [this.$t('dictionary.user')])"
      hoverable
      class="mb-4"
      :loading="loading">
      <vxe-table
        :data="userTableData"
        :show-header="false"
        border="none">
        <vxe-table-column field="label" title="label" width="180" align="right">
          <template v-slot="{ row }">{{ row.label }}：</template>
        </vxe-table-column>
        <vxe-table-column field="value" title="value">
          <template v-slot="{ row }">
            <template v-if="!row.isProjects">
              <list-body-cell-wrap copy field="value" :row="row" />
            </template>
            <template v-else>
              <vxe-table :data="row.value" show-overflow="title" border>
                <vxe-table-column field="current" width="50">
                  <template v-slot="{ row }">
                    <template v-if="row.current">
                      <a-tooltip :title="$t('scope.text_231', [$t('dictionary.project')])">
                        <a-icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                      </a-tooltip>
                    </template>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="id" title="ID" min-width="160">
                  <template v-slot="{ row }">
                    <list-body-cell-wrap copy field="id" :row="row" />
                  </template>
                </vxe-table-column>
                <vxe-table-column field="name" :title="$t('scope.text_21')" />
                <vxe-table-column field="domain" :title="$t('dictionary.domain')" />
                <vxe-table-column field="roles" :title="$t('dictionary.role')">
                  <template v-slot="{ row }">{{ getRoles(row.roles).join(', ') || '-' }}</template>
                </vxe-table-column>
                <vxe-table-column field="project_policies" :title="`${$t('shareScope.project')} ${$t('dictionary.policy')}`">
                  <template v-slot="{ row }">{{ row.project_policies ? row.project_policies.join(', ') : '-' }}</template>
                </vxe-table-column>
                <vxe-table-column field="domain_policies" :title="`${$t('shareScope.domain')} ${$t('dictionary.policy')}`">
                  <template v-slot="{ row }">{{ row.domain_policies ? row.domain_policies.join(', ') : '-' }}</template>
                </vxe-table-column>
                <vxe-table-column field="system_policies" :title="`${$t('shareScope.system')} ${$t('dictionary.policy')}`">
                  <template v-slot="{ row }">{{ row.system_policies ? row.system_policies.join(', ') : '-' }}</template>
                </vxe-table-column>
              </vxe-table>
            </template>
          </template>
        </vxe-table-column>
      </vxe-table>
    </a-card>
    <a-modal
      :title="$t('scope.text_243')"
      width="600px"
      :visible="updateDialog.visible"
      @cancel="() => updateDialog.visible = false"
      destroyOnClose>
      <template v-slot:footer>
        <a-button key="submit" type="primary" :loading="updateDialog.loading" @click="doUpdateUserInfo">{{$t('scope.text_922')}}</a-button>
        <a-button key="back" @click="() => updateDialog.visible = false">{{$t('scope.text_456')}}</a-button>
      </template>
      <update-user-info ref="updateUserInfo" :contacts="contacts" />
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ContactStatus from './components/ContactStatus'
import UpdateUserInfo from './components/Update'
import { hasServices } from '@/utils/auth'

const parseContact = function (obj) {
  const ret = {
    enabled: true,
    email: {
      enabled: false,
      verified: false,
      contact: '',
      status: '',
    },
    mobile: {
      enabled: false,
      verified: false,
      contact: '',
      status: '',
    },
  }
  if (obj.email) {
    ret.email.contact = obj.email
  }
  if (obj.international_mobile && obj.international_mobile.mobile) {
    ret.mobile.contact = '(+' + obj.international_mobile.area_code + ')' + obj.international_mobile.mobile
  }
  for (const i in obj.enabled_contact_types) {
    const contact = obj.enabled_contact_types[i]
    if (contact === 'email') {
      ret.email.enabled = true
    } else if (contact === 'mobile') {
      ret.mobile.enabled = true
    } else if (contact === 'webconsole') {
      ret.enabled = true
    }
  }
  for (const i in obj.verified_infos) {
    const verify = obj.verified_infos[i]
    if (verify.contact_type === 'email') {
      ret.email.verified = verify.verified
      if (ret.email.verified) {
        ret.email.status = 'verified'
      } else if (ret.email.contact) {
        ret.email.status = 'init'
      }
    } else if (verify.contact_type === 'mobile') {
      ret.mobile.verified = verify.verified
      if (ret.mobile.verified) {
        ret.mobile.status = 'verified'
      } else if (ret.mobile.contact) {
        ret.mobile.status = 'init'
      }
    }
  }
  return ret
}

export default {
  name: 'User',
  components: {
    ContactStatus,
    UpdateUserInfo,
  },
  data () {
    return {
      loading: false,
      isNotifyEnabled: false,
      contacts: {
        mobile: {
          contact: '',
        },
        email: {
          contact: '',
        },
      },
      updateDialog: {
        loading: false,
        visible: false,
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    projects () {
      const ret = this.userInfo.projects.map(item => {
        const current = item.id === this.userInfo.projectId
        return {
          ...item,
          current,
        }
      }).sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
      return ret
    },
    userTableData () {
      const us = this.userInfo
      const passwordExpiresAtStr = us.password_expires_at ? this.$moment(this.userInfo.password_expires_at).format() : '-'
      const ret = [
        { label: this.$t('scope.text_244'), value: us.name },
        { label: this.$t('scope.text_245'), value: us.displayname },
        { label: `${this.$t('dictionary.user')}ID`, value: us.id },
        { label: this.$t('scope.text_246'), value: us.last_login_ip },
        { label: this.$t('scope.text_247'), value: this.$moment(us.last_active_at).format('') },
        { label: this.$t('scope.text_248'), value: passwordExpiresAtStr },
        { label: this.$t('scope.text_249'), value: us.last_login_source },
        { label: this.$t('scope.text_250'), value: us.enable_mfa ? this.$t('scope.text_251') : this.$t('scope.text_252') },
        { label: this.$t('dictionary.project'), value: this.projects, isProjects: true },
      ]
      return ret
    },
  },
  destroyed () {
    this.manager = null
  },
  created () {
    this.isNotifyEnabled = hasServices('notify')
    this.manager = new this.$Manager('receivers', 'v2')
    this.fetchContact(true)
  },
  methods: {
    getRoles (rlist) {
      const roles = []
      for (let i = 0; i < rlist.length; i++) {
        roles[i] = rlist[i].name
      }
      return roles
    },
    fetchContact (isChangeLoading) {
      if (isChangeLoading) this.loading = true
      this.manager.get({ id: this.userInfo.id }).then(res => {
        this.contacts = parseContact(res.data)
        if (isChangeLoading) this.loading = false
      }).catch(() => {
        if (isChangeLoading) this.loading = false
      })
    },
    async doUpdateUserInfo () {
      this.updateDialog.loading = false
      try {
        const values = await this.$refs.updateUserInfo.getValues()
        await this.manager.performAction({
          id: this.userInfo.id,
          action: 'update-contact',
          data: { contacts: values },
        })
        this.fetchContact(false)
        this.updateDialog.visible = false
      } catch (error) {
        throw error
      } finally {
        this.updateDialog.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.user-info-item-label {
  width: 140px;
}
</style>
